import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { ThemeProvider } from "next-themes";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";

import "@/globals.css";
import "@/lib/apiClient"; // side effect: configures the shared @secure-vault/api SDK
import { AuthProvider } from "@/lib/auth-context";
import { router } from "@/router";
import { installAutoLock } from "@/stores/vault-store";

const queryClient = new QueryClient();

// Auto-lock the in-memory master key on idle / tab hide / unload.
installAutoLock();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>
);
